<template>
  <div>
    <div class="columns">
      <div class="column is-6">
        <h2 class="title is-5">Recipient #{{ index+1 }}</h2>
        <div :class="{'level lookup-result no-float':true, 'colored': details.id !== null}" v-if="!showEdit">
          <div class="level-left">
            <div class="level-item">
              <div>
                <strong>{{ details.first_name }} {{ details.last_name }}</strong>
                <br />
                <em>
                  {{ details.line1 }}
                  <br v-if="details.line2" />
                  {{ details.line2 }}
                  <br />
                  {{ details.city }}, {{ details.state }} {{ details.zip }}
                </em>
              </div>
            </div>
            <div class="level-item">
              <div>
                {{ details.phone | phone }}
                <br />
                {{ details.email }}
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <button type="button" class="button" @click="toggleEdit()">Edit</button>
            </div>
          </div>
        </div>
        <div v-show="showEdit">
          <div class="columns">
            <div class="column is-5">
              <form-group type="text"
                          label="First Name"
                          ref="first_name"
                          v-model="recipient.first_name"
                          :error="recipient.errors.get('first_name')"
                          @event="recipient.listen(recipient, $event)">
              </form-group>
            </div>
            <div class="column is-7">
              <form-group type="text"
                          label="Last Name"
                          ref="last_name"
                          v-model="recipient.last_name"
                          :error="recipient.errors.get('last_name')"
                          @event="recipient.listen(recipient, $event)">
              </form-group>
            </div>
          </div>
          <div class="columns">
            <div class="column is-8">
              <form-group type="text"
                          label="Email"
                          ref="email"
                          v-model="recipient.email"
                          :error="recipient.errors.get('email')"
                          @event="recipient.listen(recipient, $event)">
              </form-group>
            </div>
            <div class="column is-4">
              <form-group type="text"
                          label="Phone"
                          ref="phone"
                          mask="### ### ####"
                          :save-mask="false"
                          v-model="recipient.last_name"
                          :error="recipient.errors.get('phone')"
                          @event="recipient.listen(recipient, $event)">
              </form-group>
            </div>
          </div>
          <form-group type="text"
                      label="Street Address"
                      placeholder="Street and number, P.O. box, c/o"
                      ref="line1"
                      v-model="recipient.line1"
                      :error="recipient.errors.get('line1')"
                      @event="recipient.listen(recipient, $event)">
          </form-group>
          <form-group type="text"
                      placeholder="Apartment, suite, unit, building, floor, etc."
                      ref="line2"
                      v-model="recipient.line2"
                      :error="recipient.errors.get('line2')"
                      @event="recipient.listen(recipient, $event)">
          </form-group>
          <div class="columns">
            <div class="column is-4">
              <form-group type="text"
                          label="City"
                          ref="city"
                          v-model="recipient.city"
                          :error="recipient.errors.get('city')"
                          @event="recipient.listen(recipient, $event)">
              </form-group>
            </div>
            <div class="column is-4">
              <form-group type="states"
                          label="State"
                          ref="state"
                          v-model="recipient.state"
                          :error="recipient.errors.get('state')"
                          @event="recipient.listen(recipient, $event)">
              </form-group>
            </div>
            <div class="column is-4">
              <form-group type="text"
                          label="Zip"
                          ref="zip"
                          v-model="recipient.zip"
                          :error="recipient.errors.get('zip')"
                          @event="recipient.listen(recipient, $event)">
              </form-group>
            </div>
          </div>
        </div>

        <br />

        <div v-if="verify_error || address_verify">
          <strong>USPS Address Verify Result:</strong>
          <div v-if="address_verify !== null">
            {{ address_verify.line1 }}
            <br v-if="address_verify.line2" />
            {{ address_verify.line2 }}
            <br />
            {{ address_verify.city }}, {{ address_verify.state }} {{ address_verify.zip }}
            <br />
            <strong>{{ address_verify.details }}</strong>
            <br />
            <button type="button"
                    :class="{'button': true, 'is-success': addressMatch, 'is-warning': !addressMatch}"
                    @click="confirmMatch()">
              {{ addressMatch ? 'Confirm Match' : 'Update' }}
            </button>
          </div>

          <div v-if="verify_error">
            {{ verify_error.Description }}
            <br />
            <button type="button" class="button" @click="acknowledgeError()">Okay.</button>
          </div>
          <br/>
        </div>

        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <button type="button"
                      class="button is-danger"
                      @click="removeRecipient()">
                Remove Recipient
              </button>
            </div>
          </div>
          <div class="level-right" v-if="showEdit">
            <div class="level-item">
              <button type="button"
                      class="button"
                      @click="address_lookup()">
                Verify Address
              </button>
            </div>
            <div class="level-item">
              <button type="button"
                      class="button is-success"
                      @click="toggleEdit()">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <h3 class="title is-5">Items</h3>

        <label class="label">Product Lookup</label>
        <input type="text" name="product-lookup" class="input" placeholder="Type Product Name" v-model="product_lookup">
        <div class="product-lookup-results" v-if="productResults.length > 0">
          <div class="product-lookup-result"
               v-for="(product, index) in productResults"
               v-if="index < 8"
               @click="selectProduct(product)">
            {{ product.sku }} - {{ product.name }}
          </div>
        </div>
        <div class="cart-list" v-if="cart.length > 0">
          <hr />
          <div class="cart-item" v-for="(item, index) in cart">
            <div class="level">
              <div class="level-item" style="min-width: 75px;">
                <h4 class="title is-5 is-marginless">#{{ item.product.sku }}</h4>
              </div>
              <div class="level-item">
                qty: <input type="number" min="1" max="99" style="width: 75px;" class="input" v-model="item.quantity">
              </div>
              <div class="level-item">
                {{ item.product.name | limit(32) }}
              </div>
              <div class="level-item">
                <button type="button" class="button is-danger" @click="removeItem(item)">Remove</button>
              </div>
            </div>
            <div class="cart-item-greeting">
              <input type="text" class="input" v-model="item.greeting" placeholder="Greeting" style="width: 100%">
            </div>
            <div>
              <span v-for="month in item.product.ship_months"
                    :class="{'ship-month tag': true, 'is-warning': item.months.indexOf(month) !== -1}"
                    @click="selectMonth(month, item)">
                {{ months[month] }}
              </span>
              <strong>Select {{ item.product.months === null ? 1 : item.product.months }}!</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="mega-hr" />
  </div>
</template>

<script>
import * as api     from "../../store/api"
import {mapGetters} from "vuex"
import Form         from "../../helpers/Form"

export default {
  name: 'RecipientFormPart',
  props: ['details', 'index'],
  data() {
    return {
      showEdit: true,
      autocomplete: null,
      product_lookup: '',
      cart: [],
      months: {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
        8: 'August',
        9: 'September',
        10: 'October',
        11: 'November',
        12: 'December',
      },
      recipient: new Form(this, {
        uuid: 0,
        id: null,
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        line1: null,
        line2: null,
        city: null,
        state: null,
        zip: null,
      }),
      address_verify: null,
      verify_error: null,
    }
  },
  computed: {
    ...mapGetters(['products']),
    productResults() {
      if (this.product_lookup.length < 1) {
        return [];
      }
      return this.products.filter(p => p.sku.toLowerCase().indexOf(this.product_lookup.toLowerCase()) !== -1)
    },
    addressMatch() {
      if (this.address_verify !== null) {
        let localAddress = {
          line1: this.recipient.line1.toLowerCase(),
          line2: (this.recipient.line2) ? this.recipient.line2.toLowerCase() : '',
          city: this.recipient.city.toLowerCase(),
          state: this.recipient.state.toLowerCase(),
          zip: this.recipient.zip.toLowerCase(),
        };
        let uspsAddress  = {
          line1: this.address_verify.line1.toLowerCase(),
          line2: (this.address_verify.line2) ? this.address_verify.line2.toLowerCase() : '',
          city: this.address_verify.city.toLowerCase(),
          state: this.address_verify.state.toLowerCase(),
          zip: this.address_verify.zip.toLowerCase(),
        };
        let match        = true;
        if (localAddress.line1 !== uspsAddress.line1) match = false;
        if (localAddress.line2 !== uspsAddress.line2) match = false;
        if (localAddress.city !== uspsAddress.city) match = false;
        if (localAddress.state !== uspsAddress.state) match = false;
        if (localAddress.zip !== uspsAddress.zip) match = false;

        return match;
      }

      return true;
    },
  },
  mounted() {
    this.recipient.uuid       = this.details.uuid;
    this.recipient.id         = this.details.id;
    this.recipient.first_name = this.details.first_name;
    this.recipient.last_name  = this.details.last_name;
    this.recipient.email      = this.details.email;
    this.recipient.phone      = this.details.phone;
    this.recipient.line1      = this.details.line1;
    this.recipient.line2      = this.details.line2;
    this.recipient.city       = this.details.city;
    this.recipient.state      = this.details.state;
    this.recipient.zip        = this.details.zip;

    this.updateRecipient().then(() => {
      if (this.details.id !== null) {
        this.toggleEdit();
      }
      else {
        this.setupAutocomplete();
      }
    });

  },
  methods: {
    confirmMatch() {
      this.recipient.line1 = this.address_verify.line1;
      this.recipient.line2 = this.address_verify.line2;
      this.recipient.city  = this.address_verify.city;
      this.recipient.state = this.address_verify.state;
      this.recipient.zip   = this.address_verify.zip;
      this.address_verify  = null;
      this.updateRecipient();
    },
    acknowledgeError() {
      this.address_verify = null;
      this.verify_error   = null;
    },
    toggleEdit() {
      this.showEdit = !this.showEdit;
      if (!this.showEdit) {
        this.autocomplete = null
      }
      else {
        this.setupAutocomplete();
      }
    },
    address_lookup() {
      api.request(this.$store.commit, '/address/verify', {
        line1: this.recipient.line1,
        line2: this.recipient.line2,
        city: this.recipient.city,
        state: this.recipient.state,
        zip: this.recipient.zip,
      }, 'get', false, false)
         .then(data => {
           this.address_verify = data;
         })
         .catch(error => {
           if (error['error']['Error']) {
             this.verify_error = error['error']['Error'];
           }
         })
    },
    setupAutocomplete() {
      this.autocomplete = new google.maps.places.Autocomplete((this.$refs.line1.$refs.form_control.$refs.input),
        { types: ['geocode'] }
      );
      this.autocomplete.setFields(['address_component']);

      this.autocomplete.addListener('place_changed', (e) => {
        let place         = this.autocomplete.getPlace();
        let ac            = place.address_components;
        let street_number = null;
        let street_name   = null;
        let line1         = null;
        let line2         = null;
        let city          = null;
        let state         = null;
        let zip           = null;
        let zip4          = null;
        for (let x = 0; x < ac.length; x++) {
          let c = ac[x];
          if (c.types.indexOf('street_number') !== -1) {
            street_number = c.short_name;
          }
          if (c.types.indexOf('route') !== -1) {
            street_name = c.short_name;
          }
          if (c.types.indexOf('locality') !== -1) {
            city = c.short_name;
          }
          if (c.types.indexOf('administrative_area_level_1') !== -1) {
            state = c.short_name;
          }
          if (c.types.indexOf('postal_code') !== -1) {
            zip = c.short_name;
          }
          if (c.types.indexOf('postal_code_suffix') !== -1) {
            zip4 = c.short_name;
          }
        }

        line1 = street_number + ' ' + street_name;
        if (zip4 !== null) {
          zip = zip + '-' + zip4;
        }

        this.recipient.line1 = line1;
        this.recipient.city  = city;
        this.recipient.state = state;
        this.recipient.zip   = zip;
        setTimeout(() => {
          this.$refs.line1.$refs.form_control.$refs.input.value = line1;
          this.$refs.city.$refs.form_control.$refs.input.value  = city;
          this.$refs.state.$refs.form_control.$refs.input.value = state;
          this.$refs.zip.$refs.form_control.$refs.input.value   = zip;
          setTimeout(() => {
            this.$forceUpdate();
          }, 25)
        }, 25)
      });

    },
    removeRecipient() {
      this.$emit('remove', this.recipient.uuid)
    },
    updateRecipient() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          this.$refs.first_name.$refs.form_control.$refs.input.value = this.recipient.first_name;
          this.$refs.last_name.$refs.form_control.$refs.input.value  = this.recipient.last_name;
          this.$refs.email.$refs.form_control.$refs.input.value      = this.recipient.email;
          if (this.recipient.phone !== null && this.recipient.phone !== '') {
            this.$refs.phone.$refs.form_control.applyMask(this.recipient.phone);
          }
          this.$refs.line1.$refs.form_control.$refs.input.value = this.recipient.line1;
          this.$refs.line2.$refs.form_control.$refs.input.value = this.recipient.line2;
          this.$refs.city.$refs.form_control.$refs.input.value  = this.recipient.city;
          this.$refs.state.$refs.form_control.$refs.input.value = this.recipient.state;
          this.$refs.zip.$refs.form_control.$refs.input.value   = this.recipient.zip;

          setTimeout(() => {
            this.$forceUpdate();
            resolve()
          }, 25)
        }, 50)
      })
    },
    selectProduct(product) {
      this.cart.push({
        quantity: 1,
        greeting: '',
        months: [],
        product: product
      });

      this.product_lookup = '';
    },
    removeItem(item) {
      this.cart.splice(this.cart.indexOf(item), 1);
    },
    selectMonth(month, item) {
      let ref   = this.cart[this.cart.indexOf(item)];
      let limit = ref.product.months === null ? 1 : ref.product.months;
      if (ref.months.indexOf(month) === -1) {
        if (ref.months.length >= limit) {
          ref.months.shift();
        }
        ref.months.push(month);
      }
      else {
        ref.months.splice(ref.months.indexOf(month), 1);
      }
    },
  }
}
</script>

<style lang="scss">
  .product-lookup-results {
    padding: 1rem 0;
  }

  .product-lookup-result {
    padding: 0.5rem;
    background-color: #fafafa;
    border-radius: 0.5rem;
    margin-bottom: 0.25rem;

    &:hover {
      cursor: pointer;
    }
  }

  .cart-item {
    background-color: #dadada;
    padding: 0.5rem;
    margin-bottom: 0.5rem;

    .level {
      margin-bottom: 0.25rem;
    }

    .cart-item-greeting {
      margin-bottom: 0.25rem;
    }
  }

  .ship-month.tag {
    margin-right: 0.25rem;
    background-color: #fafafa;

    &:hover {
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// RecipientFormPart.vue?03e330e1